import { TFunction } from 'i18next'
import TestdataInDbRestService from './TestdataInDbRestService'

class TestdataInDbService {
  async getAllInDbConfigs(setInDbConfigs?: React.Dispatch<any>) {
    if (setInDbConfigs) {
      const inDbConfigs = await TestdataInDbRestService.getAllConfigs()
      setInDbConfigs(inDbConfigs)
    } else {
      return TestdataInDbRestService.getAllConfigs()
    }
  }

  async createConfig(config: any, t: TFunction, setInDbConfigs?: React.Dispatch<any>) {
    try {
      const createdConfig = await TestdataInDbRestService.createConfig(config)
      if (setInDbConfigs) {
        const inDbConfigs = await TestdataInDbRestService.getAllConfigs()
        setInDbConfigs(inDbConfigs)
      }
      return t('testdata.indb.config.createConfigSuccess', { name: createdConfig.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getConfigById(id: number, setInDbConfigs?: React.Dispatch<any>) {
    if (setInDbConfigs) {
      const inDbConfig = await TestdataInDbRestService.getConfigById(id)
      setInDbConfigs(inDbConfig)
    } else {
      return TestdataInDbRestService.getConfigById(id)
    }
  }

  async deleteConfig(config: any, t: TFunction, setInDbConfigs?: React.Dispatch<any>) {
    try {
      await TestdataInDbRestService.deleteConfig(config.id)
      if (setInDbConfigs) {
        const inDbConfigs = await TestdataInDbRestService.getAllConfigs()
        setInDbConfigs(inDbConfigs)
      }
      return t('testdata.indb.config.deleteConfigSuccess', { name: config.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateConfig(config: any, t: TFunction, setInDbConfigs?: React.Dispatch<any>) {
    try {
      const editedConfig = await TestdataInDbRestService.updateConfig(config)
      if (setInDbConfigs) {
        const configs = await TestdataInDbRestService.getAllConfigs()
        setInDbConfigs(configs)
      }
      return t('testdata.indb.config.editConfigSuccess', { name: editedConfig.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getAllJobs(setInDbJobs?: React.Dispatch<any>) {
    if (setInDbJobs) {
      const jobs = await TestdataInDbRestService.getAllJobs()
      setInDbJobs(jobs)
    } else {
      return TestdataInDbRestService.getAllJobs()
    }
  }

  async createJob(job: any, t: TFunction, setInDbJobs?: React.Dispatch<any>) {
    try {
      const createdJob = await TestdataInDbRestService.createJob(job)
      if (setInDbJobs) {
        const jobs = await TestdataInDbRestService.getAllJobs()
        setInDbJobs(jobs)
      }
      return t('testdata.indb.job.createJobSuccess', { name: createdJob.jobName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getJobById(id: number, setInDbJobs?: React.Dispatch<any>) {
    if (setInDbJobs) {
      const job = await TestdataInDbRestService.getJobById(id)
      setInDbJobs(job)
    } else {
      return TestdataInDbRestService.getJobById(id)
    }
  }

  async getPoliciesWithAssigned(id: number) {
    const allPolicies: any[] = await TestdataInDbRestService.getAllPolicies()
    const job: any = await TestdataInDbRestService.getJobById(id)
    const jobPolicies: any[] = job.policies

    const policyIds: number[] = jobPolicies.map((policy: { id: any }) => policy.id)

    allPolicies.forEach((policy) => {
      if (policyIds.includes(policy.id)) {
        policy.isAssigned = true
      } else {
        policy.isAssigned = false
      }
    })
    return allPolicies
  }

  async deleteJob(job: any, t: TFunction, setInDbJobs?: React.Dispatch<any>) {
    try {
      await TestdataInDbRestService.deleteJob(job.id)
      if (setInDbJobs) {
        const jobs = await TestdataInDbRestService.getAllJobs()
        setInDbJobs(jobs)
      }
      return t('testdata.indb.job.deleteJobSuccess', { name: job.jobName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async startJob(job: any, t: TFunction, setInDbJobs?: React.Dispatch<any>) {
    try {
      await TestdataInDbRestService.startJob(job.id)
      if (setInDbJobs) {
        const jobs = await TestdataInDbRestService.getAllJobs()
        setInDbJobs(jobs)
      }
      return t('testdata.indb.job.startSuccess', { name: job.jobName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async assingPoliciesToJob(policies: any[], jobId: number, jobName: String, t: TFunction) {
    await TestdataInDbRestService.assignPoliciesToJob(
      jobId,
      policies.filter((policy) => policy.isAssigned).map((policy) => policy.id)
    )
    return t('testdata.indb.job.assignSuccess', { jobName: jobName })
  }

  async getAllPolicies(setInDbPolicies?: React.Dispatch<any>) {
    if (setInDbPolicies) {
      const policies = await TestdataInDbRestService.getAllPolicies()
      setInDbPolicies(policies)
    } else {
      return TestdataInDbRestService.getAllPolicies()
    }
  }

  async createPolicy(policy: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
    try {
      const createdPolicy = await TestdataInDbRestService.createPolicy(policy)
      if (setInDbPolicies) {
        const policies = await TestdataInDbRestService.getAllPolicies()
        setInDbPolicies(policies)
      }
      return t('testdata.indb.policy.createPolicySuccess', { name: createdPolicy.configname })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getPolicyById(id: number, setInDbPolicies?: React.Dispatch<any>) {
    if (setInDbPolicies) {
      const policies = TestdataInDbRestService.getAllPolicies()
      setInDbPolicies(policies)
    } else {
      return TestdataInDbRestService.getPolicyById(id)
    }
  }

  async deletePolicy(policy: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
    try {
      await TestdataInDbRestService.deletePolicy(policy.id)
      if (setInDbPolicies) {
        const policies = await TestdataInDbRestService.getAllPolicies()
        setInDbPolicies(policies)
      }
      return t('testdata.indb.policy.deletePolicySuccess', { name: policy.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async populateTable(policy: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
    try {
      await TestdataInDbRestService.populatePolicyTable(policy.id)
      if (setInDbPolicies) {
        const policies = await TestdataInDbRestService.getAllPolicies()
        setInDbPolicies(policies)
      }
      return t('testdata.indb.policy.populateTableSuccess', { name: policy.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async generateRows(config: any, t: TFunction) {
    try {
      const requestId = await TestdataInDbRestService.generateRows(config)
      return t('testdata.indb.policy.generateRowsSuccess', { name: config.configName, requestId: requestId })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updatePolicy(policy: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
      try {
          var properties = Object.assign({}, policy)
          if (properties.method === 'In-Table Replacement') {
              delete properties.destDb
              delete properties.destTable
              properties.inTableReplace = true
              properties.emptyDestTeble = false
          } else if (properties.method === 'Table to Table Protection') {
              properties.inTableReplace = false
          }
          const editedPolicy = await TestdataInDbRestService.updatePolicy(properties)
          if (setInDbPolicies) {
              const policies = await TestdataInDbRestService.getAllPolicies()
              setInDbPolicies(policies)
          }
          return t('testdata.indb.policy.editPolicySuccess', { name: editedPolicy.configName })
      } catch (error) {
          return Promise.reject(error)
      }
  }
  
  async copyPolicy(row: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
      try {
          const editedPolicy = await TestdataInDbRestService.copyPolicy(row)
          if (setInDbPolicies) {
              const policies = await TestdataInDbRestService.getAllPolicies()
              setInDbPolicies(policies)
          }
          return t('testdata.soap.copyWebServiceSuccess', { name: editedPolicy.configName })
      } catch (error) {
          return Promise.reject(error)
      }
  }

  async addTokenizerConfig(config: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
      try {
          await TestdataInDbRestService.addTokenizerConfig(config)
          if (setInDbPolicies) {
              const policies = await TestdataInDbRestService.getAllPolicies()
              setInDbPolicies(policies)
          }
          return t('testdata.tokenizerConfig.assignTokConfigSuccess', { configName: config.columnName })
      } catch (error) {
          return Promise.reject(error)
      }
  }
  
  async updateTokenizerConfig(config: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
    try {
      await TestdataInDbRestService.updateTokenizerConfig(config)
      if (setInDbPolicies) {
        const policies = await TestdataInDbRestService.getAllPolicies()
        setInDbPolicies(policies)
      }
      return t('testdata.tokenizerConfig.editTokConfigSuccess', { name: config.columnName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async deleteTokenizerConfig(config: any, t: TFunction, setInDbPolicies?: React.Dispatch<any>) {
    try {
      await TestdataInDbRestService.deleteTokenizerConfig(config.id)
      if (setInDbPolicies) {
        const policies = await TestdataInDbRestService.getAllPolicies()
        setInDbPolicies(policies)
      }
      return t('testdata.tokenizerConfig.deleteTokConfigSuccess', { name: config.columnName })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default new TestdataInDbService() as TestdataInDbService